import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import theme from 'theme/theme';

const StyledLabel = styled.div`
    position: relative;
    padding: 10px 20px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    font-size: 16px;
    line-height: 1.2;
    min-height: 33px;
    max-height: 33px;
    background-color: ${ (props) => {
        if (props.open) {
            return theme.accordion.open;
        }

        return theme.accordion.closed;
    } };
    border: 1px solid ${ theme.accordion.border };
    overflow: hidden;

    &:after {
        content: '';
        position: absolute;
        padding: 0;
        margin: 0;
        top: 50%;
        right: 20px;
        bottom: 0;
        display: block;
        height: 10px;
        width: 10px;
        border: 1px solid black;
        border-width: 0 3px 3px 0;
        transition: transform .5s ease-in-out;

        transform: translate(-20px, -50%) rotate(-45deg);
        -webkit-transform: translate(-20px, -50%) rotate(-45deg);

        ${ (props) => {
            if (props.open) {
                return `
                    transform: translate(-20px, -50%) rotate(45deg);
                    -webkit-transform: translate(-20px, -50%) rotate(45deg);
                `;
            }
        } }
    }

    &:hover {
        background-color: darken(${ theme.accordion.highlight }, 20%);
        cursor: pointer;
    }
`;

const AccordionLabel = (props) => {
    const {
        children,
        handleClick,
        open,
    } = props;

    return (
        <StyledLabel
            onClick={ handleClick }
            open={ open }
        >
            { children }
        </StyledLabel>
    );
};

AccordionLabel.propTypes = {
    children: PropTypes.node.isRequired,
    handleClick: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
};

export default AccordionLabel;



// WEBPACK FOOTER //
// ./src/components/ui/accordion/AccordionLabel.js